import { render, staticRenderFns } from "./MealPlanView.vue?vue&type=template&id=323fbce4&scoped=true"
import script from "./MealPlanView.vue?vue&type=script&lang=js"
export * from "./MealPlanView.vue?vue&type=script&lang=js"
import style0 from "./MealPlanView.vue?vue&type=style&index=0&id=323fbce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323fbce4",
  null
  
)

export default component.exports